import React from 'react';
import { Link } from 'gatsby';

import Title from '../Title';
import FaqCard from './FaqCard';
import faqs from '../../constants/faqs';
import styles from './faqs.module.css';

const Faqs = () => {
  return (
    <section className={styles.faqs}>
      <Title title={`Faq's`}></Title>
      <div className={styles.faqsGrid}>
        {faqs.map((faq, index) => (
          <FaqCard key={index} faq={faq}></FaqCard>
        ))}
        <div className={styles.buttons}>
          <Link className="btn-primary" to="/about">
            learn more
          </Link>
          <Link className="btn-primary" to="/products">
            rent now
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Faqs;
